import { useState, type FC } from "react";
import BrandLogo from "../../components/BrandLogo";
import { Button } from "../../components/ui/button";
import { gluceraAssessmentCta } from "../../utils/gluceraTypography";
import { Card } from "../../components/ui/card";
import { Label } from "../../components/ui/label";
import RadioDot from "../../components/common/RadioDot";
import { useNavigate } from "react-router-dom";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import SessionStorageHelper from "../../utils/sessionStorageHelper";

const EatingWindowPage: FC = () => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState<string>("");

  const options = [
    "16:8 (Fast 16 hrs / Eat 8 hrs)",
    "18:6 (Fast 18 hrs / Eat 6 hrs)",
    "14:10 (Fast 14 hrs / Eat 10 hrs)",
    "My eating window varies",
  ];

  const handleNext = () => {
    if (!selected) {
      return;
    }

    // Use Django choice keys (first value in tuple)
    SessionStorageHelper.saveMultipleFields({
      fasting_window_type: selected,
      intermittent_fasting: "Yes — I follow a fasting window",
    });

    navigate("/glucera" + GluceraNavigationRoutes.ASSESSMENT_SUMMARY);
  };

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header */}
        <div className="space-y-4 px-4 pb-4 pt-safe">
          <BrandLogo />

          {/* Assessment Progress */}
          <p className="text-center text-subhead text-muted-foreground">
            Assessment 10 of 11
          </p>
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col px-6 py-2">
          <div className="mb-6 space-y-2">
            <Label className="text-subhead text-foreground">
              What's your typical eating window?
            </Label>
          </div>

          <div className="space-y-3">
            {options.map(option => (
              <Card
                key={option}
                onClick={() => setSelected(option)}
                className={`cursor-pointer p-3 transition-all hover:shadow-md ${selected === option
                  ? "border border-primary bg-primary/5"
                  : "border border-border hover:border-primary/50"
                  }`}
              >
                <div className="flex items-center gap-3">
                  <RadioDot selected={selected === option} />
                  <span className="flex-1 text-subhead text-foreground">
                    {option}
                  </span>
                </div>
              </Card>
            ))}
          </div>

          {/* Button Container */}
          <div className="mt-auto pt-4">
            <Button
              onClick={handleNext}
              disabled={!selected}
              className={gluceraAssessmentCta}
            >
              {selected ? "Next" : "Select Eating Window"}
            </Button>
          </div>
        </div>

        {/* Safe area padding */}
        <div className="pb-safe p-2" />
      </div>
    </div>
  );
};

export default EatingWindowPage;
